import { unallowedWords } from '../variables/unallowedWords';

export const containsProfanity = (word) =>
  unallowedWords.some((unallowedWord) =>
    word.toLowerCase().includes(unallowedWord.toLowerCase()),
  );
